import { Select, SelectProps } from 'antd';

import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

import { useStateDebounce } from '@/hooks';
import { useDocumentTypes } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';
import {
  DocumentType,
  ListDocumentTypesQuery,
} from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';

interface Props extends Omit<SelectProps, 'options' | 'onChange'> {
  onChange?: (value: number, documentType: DocumentType) => void;
  queryParams?: ListDocumentTypesQuery;
}

const DocumentTypesSelectField: React.FC<Props> = ({
  queryParams,
  ...props
}) => {
  const [search, setSearch] = useStateDebounce<string>();

  const { data, isFetching } = useDocumentTypes({
    description: search,
    rows: 50,
    active: true,
    ...queryParams,
  });

  const documentTypes = flatInfiniteData(data);

  return (
    <Select
      allowClear
      showSearch
      onSearch={setSearch}
      filterOption={false}
      loading={isFetching}
      style={{ width: '100%' }}
      {...props}
      onChange={(value) => {
        if (!!props?.onChange) {
          props?.onChange(
            value,
            documentTypes.find((item) => item.id === value) as DocumentType,
          );
        }
      }}
      options={documentTypes?.map((documentType) => ({
        value: documentType.id,
        label: documentType.description,
      }))}
    />
  );
};

export default DocumentTypesSelectField;
